import React, {useState, useEffect} from 'react';
import { useData } from "../../components/context/DataContext";
import { useScreenShow, useScreenShowUpdate } from "../../components/context/ScreenContext";
import { useModuleIndex, useModuleIndexUpdate, useModuleScreenCount, useModuleScreenCountUpdate } from "../../components/context/ModuleContext";
import { useModalType, useModalTypeUpdate, useModalUpdate } from "../../components/context/ModalContext";
import { useScreenType, useScreenTypeUpdate } from "../../components/context/MixContext";
import { motion } from "framer-motion";

import mod0Img from '../../assets/images/mod0-img.png';
import mod1Img from '../../assets/images/mod1-img.png';
import mod2Img from '../../assets/images/mod2-img.png';
import mod3Img from '../../assets/images/mod3-img.png';
import mod4Img from '../../assets/images/mod4-img.png';
import mod5Img from '../../assets/images/mod5-img.png';



import './MenuLink.css'

const MenuLink = (props) => {
    // data
    const json = useData();

    const images = {
        0: mod0Img,
        1: mod1Img,
        2: mod2Img,
        3: mod3Img,
        4: mod4Img,
        5: mod5Img,
    };

    // Show modal
    const popupModalSet = useModalUpdate();

    // Screen show
    const getScreenShow = useScreenShow();
    const setScreenShow = useScreenShowUpdate();

    // module type
    const getModalType = useModalType();
    const setModalType = useModalTypeUpdate();

    // module index
    const getModuleIndex = useModuleIndex();
    const setModuleIndex = useModuleIndexUpdate();

    // Screen count
    const getScreenCount = useModuleScreenCount();
    const setScreenCount = useModuleScreenCountUpdate();

    // Screen type
    const getScreenType = useScreenType();
    const setScreenType = useScreenTypeUpdate();


    const handleClick = () => {
        setModalType("submenu");
        setScreenCount(props.count)
        setModuleIndex(props.indx);
        popupModalSet(true);
    }

    return (
        
        <motion.div className="link-wrap"
            initial={{ opacity: 0, scale: .5 }}
            animate={{ opacity: 1, scale: 1 }} 
            transition={{ delay: props.delay, duration: .5 }}
        >
            <div className="link-click-wrap" onClick={handleClick}>
                <div className="link-img">
                    <img src={images[props.indx]} width="100%" alt="Menu" />
                </div>
                <div className="link-title">
                    {json && json.screen[props.indx].title}
                </div>
                <div className="link-click"></div>
            </div>
        </motion.div>

    );
};

export default MenuLink;